import i18n from "i18next";
import { formatInTimeZone } from "date-fns-tz";
/* eslint-disable import/no-duplicates */
/* import/no-duplicates: date-fns is badly detected as duplicate */
import { Locale } from "date-fns";
import { enUS, nl } from "date-fns/locale";

export const AMS = "Europe/Amsterdam";
const DATE_FNS_LOCALES: Record<"nl" | "en", Locale> = { nl, en: enUS };

// NL issued: "Opgesteld: dinsdag 5 mei 2026 11.31 uur[ UTC]"
export const issuedNL =
  (tz: string, addUTC: boolean) =>
  (iso: string): string => {
    const date = formatInTimeZone(new Date(iso), tz, "EEEE d MMMM yyyy HH'.'mm 'uur'", {
      locale: DATE_FNS_LOCALES["nl"],
    });
    const key = addUTC
      ? "widgets.maritime_broadcast.issued_utc"
      : "widgets.maritime_broadcast.issued";
    return i18n.t(key, { date, lng: "nl" });
  };

// EN issued: "Issued: 5 may 2026 09:31 UTC"
export const issuedEN = (iso: string): string => {
  const d = new Date(iso);
  const month = formatInTimeZone(d, "UTC", "MMMM", {
    locale: DATE_FNS_LOCALES["en"],
  }).toLowerCase();
  const date = `${formatInTimeZone(d, "UTC", "d")} ${month} ${formatInTimeZone(d, "UTC", "yyyy HH:mm")}`;
  return i18n.t("widgets.maritime_broadcast.issued_utc", { date, lng: "en" });
};

// Period headers
export const periodHeaderNL = (start: string, end: string): string =>
  i18n.t("widgets.maritime_broadcast.period_header", {
    from: formatInTimeZone(new Date(start), AMS, "HH:mm"),
    to: formatInTimeZone(new Date(end), AMS, "HH:mm"),
    lng: "nl",
  });

export const periodHeaderEN_noDay = (start: string, end: string): string =>
  i18n.t("widgets.maritime_broadcast.period_header_utc", {
    from: formatInTimeZone(new Date(start), "UTC", "HH:mm"),
    to: formatInTimeZone(new Date(end), "UTC", "HH:mm"),
    lng: "en",
  });

export const periodHeaderSchip = (start: string, end: string): string =>
  i18n.t("widgets.maritime_broadcast.period_header_with_day_utc", {
    from: formatInTimeZone(new Date(start), "UTC", "EEEE HH:mm", {
      locale: DATE_FNS_LOCALES["nl"],
    }),
    to: formatInTimeZone(new Date(end), "UTC", "EEEE HH:mm", {
      locale: DATE_FNS_LOCALES["nl"],
    }),
    lng: "nl",
  });

export const periodHeaderNavtex = (start: string, end: string): string =>
  i18n.t("widgets.maritime_broadcast.period_header_with_day_utc", {
    from: formatInTimeZone(new Date(start), "UTC", "EEEE HH:mm", {
      locale: DATE_FNS_LOCALES["en"],
    }),
    to: formatInTimeZone(new Date(end), "UTC", "EEEE HH:mm", {
      locale: DATE_FNS_LOCALES["en"],
    }),
    lng: "en",
  });

// Footers
export const footerNL =
  (tz: string, addUTC: boolean) =>
  (iso: string): string[] => {
    const date = formatInTimeZone(new Date(iso), tz, "EEEE dd MMMM yyyy HH'.'mm 'uur'", {
      locale: DATE_FNS_LOCALES["nl"],
    });
    const key = addUTC
      ? "widgets.maritime_broadcast.footer_utc"
      : "widgets.maritime_broadcast.footer";
    const line = i18n.t(key, { date, lng: "nl" });
    return addUTC
      ? [line]
      : [line, i18n.t("widgets.maritime_broadcast.footer_local_time_note", { lng: "nl" })];
  };

export const footerEN = (iso: string): string[] => {
  const d = new Date(iso);
  const month = formatInTimeZone(d, "UTC", "MMMM", {
    locale: DATE_FNS_LOCALES["en"],
  }).toLowerCase();
  const date = `${formatInTimeZone(d, "UTC", "EEEE dd", { locale: DATE_FNS_LOCALES["en"] })} ${month} ${formatInTimeZone(d, "UTC", "yyyy HH'.'mm")}`;
  return [i18n.t("widgets.maritime_broadcast.footer_utc", { date, lng: "en" })];
};
